import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { httpSwevenneCustomerJwtInterceptor } from './interceptor/http-swevenne-customer-jwt.interceptor';
import { AddToCartService } from './service/add-to-cart.service';
import { AuthGuard } from './service/auth.guard';
import { AuthService } from './service/auth.service';
import { ConstantsService } from './service/constants.service';
import { DataProviderService } from './service/data-provider.service';
import { EventCenterS } from './service/event-center.s';
import { NotificationService } from './service/notification.service';
import { OrdersService } from './service/orders.service';
import { ReviewsService } from './service/reviews.service';
import { TodayOffersService } from './service/today-offers.service';
import { UserService } from './service/user.service';
import { WishlistService } from './service/wishlist.service';

export const appConfig: ApplicationConfig = {
    providers: [

        {
            provide: APP_INITIALIZER,
            useFactory: setUserFromLocalStorage,
            deps: [AuthService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: setAMUserFromLocalStorage,
            deps: [UserService],
            multi: true,
        },

        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(routes, withInMemoryScrolling({
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled'
        })),
        AuthService,
        UserService,
        DialogService,
        MessageService,
        DataProviderService,
        NotificationService,
        ConfirmationService,
        ConstantsService,
        AddToCartService,
        ReviewsService,
        WishlistService,
        TodayOffersService,
        OrdersService,
        AuthGuard,
        EventCenterS,
        provideHttpClient(withInterceptors([
            httpSwevenneCustomerJwtInterceptor
        ])),
        provideAnimations(),
        providePrimeNG({
            theme: {
                preset: Aura
            }
        }), provideClientHydration(withEventReplay())
    ]
};

export function setUserFromLocalStorage(authCS: AuthService) {
    return () => { // return function which returns promise.
        return new Promise<void>(async (resolve) => {
            try {
                const localStorageUser = authCS.getUserFromLocalStorage(environment.crypto.passJWT);
                if (localStorageUser) {
                    authCS.gUser = localStorageUser;
                    authCS.token.accessToken = <any>authCS.gUser.accessToken;
                    authCS.token.refreshToken = <any>authCS.gUser.refreshToken;
                }
            } catch (e) {
                console.log(e);
            }
            resolve();
        });
    };
}

export function setAMUserFromLocalStorage(userS: UserService) {
    return () => { // return function which returns promise.
        return new Promise<void>(async (resolve) => {
            try {
                const localStorageUser = userS.getAMUserFromLocalStorage(environment.crypto.passJWT);
                if (localStorageUser) {
                    userS.amUser = localStorageUser;
                }
            } catch (e) {
                console.log(e);
            }
            resolve();
        });
    };
}
